import { useState } from 'react';

import { CircularProgress, IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

import { ITileCacheSeedOperation, TileCacheSeedOperationStatus } from '../../MapComponents/TileCache/types';
import DownloadListItemStatusInfoPopup from './downloadListItemStatusInfoPopup';

import uiStyles from "../../../Lib/UI/UI.module.css";


interface DownloadListItemStatusProps {
    op: ITileCacheSeedOperation;
}

const DownloadListItemStatus = (props: DownloadListItemStatusProps): JSX.Element => {

    const [popupIsOpen, setPopupIsOpen] = useState<boolean>(false);

    return (
        <>
        {(props.op.status === TileCacheSeedOperationStatus.InProgress) &&
            <CircularProgress 
                aria-label="Downloading..." 
                title="Downloading..."
            />
        }
        {props.op.status !== TileCacheSeedOperationStatus.InProgress &&
            <IconButton edge="end" aria-label="More information..." title="More information..." className={uiStyles.list_status} onClick={() => setPopupIsOpen(true)}>
                <InfoIcon fontSize='large' />
            </IconButton>
        }

            <DownloadListItemStatusInfoPopup op={props.op} isOpen={popupIsOpen} onClose={() => setPopupIsOpen(false)} />
        </>
    );
};

export default DownloadListItemStatus;